<script>
//const URL = 'http://localhost:8080/bidding'
const URL = 'http://jingweizhaobiao.com/bidding'

export default {
  URL
};
</script>